import React from 'react';
import {
  Col,
  Row,
  Panel,
  FormGroup,
  FormControl,
  Button
} from 'react-bootstrap';

import './prize-search.css';

const PrizesSearch = (props) => {
  return (
    <Panel className="prize-filter">
      <Row>
        <Col md={9}>
          <FormGroup>
            <FormControl
              placeholder="Search by customer number, incentive name, prize name..."
              value={props.searchValue}
              onChange={(event) => props.onInputChange(event)}
            />
          </FormGroup>
        </Col>
        <Col md={3} className="actions prize-search">
          <Button className="red-ghost-btn" onClick={props.onSearch}>
            Search
          </Button>

          <Button className="red-ghost-btn" onClick={props.onClear}>
            Clear search
          </Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default PrizesSearch;



// WEBPACK FOOTER //
// ./src/components/admin/prizes/list/prize-search.js